<div>
    <app-cscancellation-form></app-cscancellation-form>
</div>
<div>
    <app-cscancellation-list></app-cscancellation-list>
</div>

